import { ContactSupportLocations } from "@custom-types/types";
import { Link } from "@mui/material";
import { runtimeConfig } from "@src/runtime-config";
import { blue } from "@flat-ui";
import { contactSupport } from "@utils/email-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";

interface Props {
  /** The location from where the support link is being accessed */
  location: ContactSupportLocations;
}

/** Creates a simple component to show a link to contact support */
export function SphereSupportLink({ location }: Props): JSX.Element {
  const { trackEvent } = useTrackEvent();

  return (
    <Link
      fontWeight="600"
      color={blue[500]}
      onClick={() =>
        contactSupport({
          location,
          trackEvent,
        })
      }
      sx={{ cursor: "pointer" }}
    >
      {runtimeConfig.mailSupportAddress}
    </Link>
  );
}
